import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Home from "./Pages/Public/Home";
import CompetitionTerms from "./Pages/Public/CompetitionTerms";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/competition-terms-and-conditions" element={<CompetitionTerms />} />

                {/* Any other URL → Home */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
